<div class="panes" [class.right]="activePane === 'right'">
  <div>
    <ng-content select="[leftPane]"></ng-content>
  </div>
  <div>
    <ng-content select="[rightPane]"></ng-content>
  </div>
</div>
